import { render, staticRenderFns } from "./Receipt-totals.vue?vue&type=template&id=49be16c2&scoped=true"
import script from "./Receipt-totals.vue?vue&type=script&lang=js"
export * from "./Receipt-totals.vue?vue&type=script&lang=js"
import style0 from "./Receipt-totals.vue?vue&type=style&index=0&id=49be16c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be16c2",
  null
  
)

export default component.exports